<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header" style="padding-bottom: 5px !important">
                    <div class="row">
                        <div class="col-6">
                            <h5 class="pb-2">طلب انضمام</h5>
                         
                        </div>

                        <!-- <div class="col-6 header-titles">
                            <a routerLink="/content/admin/InsertJoinRequest" class="d-block">
                                <button class="btn pull-right" type="button">
                                    <span class="m-2">إدخال طلب انضمام</span>
                                    <i class="fa fa-plus"></i>
                                </button>
                            </a>
                        </div> -->
                    </div>
                </div>
                <div class="card-block row">
                    <div class="col-sm-12 col-lg-12 col-xl-12">
                        <div class="table-responsive">
                            <table class="table table-responsive-sm">
                                <thead>
                                    <tr class=" ">
                                        <th scope="col"></th>
                                        <th scope="col">اسم الطلب</th>
                                        <th scope="col">نوع الطلب</th>
                                        <th scope="col">نوع الانضمام</th>
                                        <th scope="col">نوع المؤهل</th>
                                        <th scope="col">الهاتف</th>
                                        <th scope="col">الدولة</th>
                                        <th scope="col">المحافظة</th>
                                        <th scope="col">المدينة</th>
                                        <th scope="col">الموقع</th>

                                        <th scope="col"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let view of joinrequests;let x = index" class=" ">
                                        <td scope="row" class="p-2">{{x+1}}</td>
                                        <td class="p-2">{{view.name}}</td>
                                        <td class="p-2">{{view.requestTypeTitle}}</td>
                                        <td class="p-2">{{view.joinTypeTitle}}</td>
                                        <td class="p-2">{{view.qualificationTitle}}</td>
                                        <td class="p-2">{{view.mobile}}</td>
                                        <td class="p-2">{{view.countryTitle}}</td>
                                        <td class="p-2">{{view.governorateTitle}}</td>
                                        <td class="p-2">{{view.cityTitle}}</td>
                                        <td class="p-2">{{view.address}}</td>

                                            <td class="font-style chose"> 
                                                <button class="btn pull-right"
                                                style="color: rgba(35, 118, 241, 0.667); padding: 7px"
                                                (click)="update(view)">
                                                <i class="fa fa-pencil"></i>
                                            </button>
                                                   <button class="btn  pull-right"  style="color: red; padding: 7px"
                                                   (click)="delete(view.id)">
                                                    <i class="fa fa-trash"></i>
                                                       </button>
                                               
                                            
                                            </td>
                                        </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>




